"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterProcedure = void 0;
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-native/no-inline-styles */
const react_native_1 = require("react-native");
const react_1 = __importStar(require("react"));
const native_1 = require("@react-navigation/native");
const RegisterProcedure_web_style_1 = require("./RegisterProcedure.web.style");
const GlobalStyles_1 = require("../../../../helper/GlobalStyles");
const enums_1 = require("../../../../enums");
const hooks_1 = require("../../../../store/hooks");
const reducers_1 = require("../../../../store/reducers");
const molecules_1 = require("../../../molecules");
const organisms_1 = require("../../../organisms");
const react_native_gesture_handler_1 = require("react-native-gesture-handler");
const Breakpoints_1 = require("../../../../helper/Breakpoints");
const User_service_1 = __importDefault(require("../../../../services/User.service"));
const atome_1 = require("../../../atome");
const InputLoader_1 = __importDefault(require("../../../atome/InputLoader/InputLoader"));
const Terms_service_1 = __importDefault(require("../../../../services/Terms.service"));
// @ts-ignore
function RegisterProcedure({ navigation }) {
    // STATE MANAGEMENT
    const auth = (0, hooks_1.useAppSelector)(reducers_1.selectAuth);
    const refStep1 = (0, react_1.useRef)(null);
    const isFocused = (0, native_1.useIsFocused)();
    // FIELDS
    const [cannabisPatient, setCannabisPatient] = (0, react_1.useState)(0);
    const [firstname, setFirstname] = (0, react_1.useState)('');
    const [lastname, setLastname] = (0, react_1.useState)('');
    const [email, setEmail] = (0, react_1.useState)('');
    const [phoneNumber, setphoneNumber] = (0, react_1.useState)('');
    const [password, setPassword] = (0, react_1.useState)('');
    const [repeatedPassword, setRepeatedPassword] = (0, react_1.useState)('');
    const [agbs, setAgbs] = (0, react_1.useState)(false);
    const [newsletter, setNewsletter] = (0, react_1.useState)(false);
    const [dataProtection, setDataProtection] = (0, react_1.useState)(false);
    const [morning, setMorning] = (0, react_1.useState)('');
    const [noon, setNoon] = (0, react_1.useState)('');
    const [afternoon, setAfternoon] = (0, react_1.useState)('');
    const [terms, setTerms] = (0, react_1.useState)([]);
    const [isModalVisible, setModalVisible] = (0, react_1.useState)(false);
    const [modalContent, setModalContent] = (0, react_1.useState)('');
    // UTILITY
    const [isSaving, setSaving] = (0, react_1.useState)(false);
    const passwordRegex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])/;
    const mailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    // VALIDATION
    const [error, setError] = (0, react_1.useState)({
        cannabisPatientEmpty: false,
        firstnameEmpty: false,
        lastnameEmpty: false,
        emailEmpty: false,
        emailCorrect: false,
        emailTaken: false,
        phoneEmpty: false,
        phoneShort: false,
        phoneLong: false,
        passwordReq: false,
        passwordEqual: false,
        agbs: false,
        dataProtection: false,
    });
    // === STATE SECTION START ===
    (0, react_1.useEffect)(() => {
        if (refStep1.current !== null) {
            refStep1.current.scrollTo({ x: 0, y: 0 });
        }
        getActiveTerms();
    }, [isFocused]);
    (0, react_1.useEffect)(() => {
        if (auth.isAuthenticated) {
            navigation.navigate('Profile');
        }
    }, [auth.isAuthenticated]);
    // === STATE SECTION END ===
    const getContent = () => {
        return (react_1.default.createElement("div", { style: { overflowY: 'scroll', overflowX: 'hidden', fontSize: '1rem' }, dangerouslySetInnerHTML: { __html: modalContent } }));
    };
    const openModal = (term) => {
        const content = terms.find(t => t.type === term)?.termText || '';
        setModalContent(content);
        setModalVisible(true);
    };
    const closeModal = () => {
        setModalContent('');
        setModalVisible(false);
    };
    const getActiveTerms = async () => {
        Terms_service_1.default.getActiveTerms().then(res => {
            if (res.error) {
                console.log(res);
                return;
            }
            const resTerms = res.data;
            setTerms(resTerms.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()));
        });
    };
    // === FUNCTIONALITY START ===
    /**
     * Checks if an email has more than one '@' sign
     *
     * @param {string} [mail='']
     * @return {boolean} true if email has more than one '@'
     */
    const SecondMailValidator = (mail = '') => {
        const after = mail.substring(mail.indexOf('@') + 1);
        const howManyMailSigns = after.split('.').length - 1;
        if (howManyMailSigns === 1) {
            return false;
        }
        return true;
    };
    const validate = async () => {
        const newError = {
            cannabisPatientEmpty: cannabisPatient === -1,
            firstnameEmpty: firstname === '',
            lastnameEmpty: lastname === '',
            emailEmpty: email === '',
            emailCorrect: email === ''
                ? false
                : !mailRegex.test(email) || SecondMailValidator(email),
            emailTaken: false,
            phoneEmpty: phoneNumber === '',
            phoneShort: phoneNumber.length < 6 && phoneNumber !== '',
            phoneLong: phoneNumber.length > 17,
            passwordReq: !passwordRegex.test(password) || password.length < 8,
            passwordEqual: password !== repeatedPassword,
            agbs: !agbs,
            dataProtection: !dataProtection,
        };
        setError(newError);
        if (newError.emailEmpty === false && newError.emailCorrect === false) {
            const resp = await User_service_1.default.checkEmail({ email });
            if (resp.status !== 200 && resp.status === 409) {
                setError({ ...newError, emailTaken: true });
                newError.emailTaken = true;
            }
        }
        return newError;
    };
    const save = async () => {
        let newError = await validate();
        if (Object.values(newError).every(value => value === false)) {
            const registerData = {
                patient: {
                    firstname: firstname,
                    lastname: lastname,
                    email: email,
                    mobile: phoneNumber,
                    phoneAvailabilities: [morning, noon, afternoon]
                        .filter(Boolean)
                        .join(', '),
                    isAlreadyCannabisPatient: Boolean(cannabisPatient),
                },
                password: password,
                isNewsletterAgree: newsletter,
            };
            if (!isSaving) {
                setSaving(true);
                try {
                    const resp = await User_service_1.default.register(registerData);
                    if (!resp.error) {
                        navigation.navigate('RegisterSuccess', { email: email });
                    }
                    setSaving(false);
                }
                catch (e) {
                    console.log(e);
                }
            }
        }
    };
    // === FUNCTIONALITY END ===
    return (react_1.default.createElement(react_native_1.SafeAreaView, { style: { backgroundColor: 'white' } },
        react_1.default.createElement(react_native_gesture_handler_1.ScrollView, { style: RegisterProcedure_web_style_1.styles.scrollview, ref: refStep1 },
            react_1.default.createElement(atome_1.Modal, { modalVisible: isModalVisible, setModalVisible: setModalVisible, cb: closeModal, disableSecondaryButton: true }, getContent()),
            react_1.default.createElement(organisms_1.BaseHeader, { navigation: navigation }),
            react_1.default.createElement(react_native_1.View, { style: RegisterProcedure_web_style_1.styles.header }, !Breakpoints_1.isDesktop && (react_1.default.createElement(atome_1.Link, { style: [RegisterProcedure_web_style_1.styles.logo], href: "https://www.nowomed.com" },
                react_1.default.createElement(atome_1.Icon, { icon: "nowomed" })))),
            react_1.default.createElement(react_native_1.View, { style: RegisterProcedure_web_style_1.styles.container },
                react_1.default.createElement(atome_1.Text, { style: [RegisterProcedure_web_style_1.styles.heading3, !Breakpoints_1.isDesktop && GlobalStyles_1.globalStyles.marginTop50] }, "Kostenfreie Therapieanfrage stellen"),
                react_1.default.createElement(react_native_1.View, null,
                    react_1.default.createElement(react_native_1.View, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet
                            ? GlobalStyles_1.globalStyles.column
                            : [GlobalStyles_1.globalStyles.row, GlobalStyles_1.globalStyles.marginRow] },
                        react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.row] },
                            react_1.default.createElement(react_native_1.View, { style: [
                                    Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                        ? error.firstnameEmpty
                                            ? GlobalStyles_1.globalStyles.marginBottom30
                                            : GlobalStyles_1.globalStyles.marginBottom10
                                        : GlobalStyles_1.globalStyles.flex2,
                                    GlobalStyles_1.globalStyles.marginRight10,
                                    GlobalStyles_1.globalStyles.flex2,
                                ] },
                                react_1.default.createElement(atome_1.Label, { style: [RegisterProcedure_web_style_1.styles.label] }, "Vorname"),
                                react_1.default.createElement(atome_1.InputField, { hasError: error.firstnameEmpty, onChange: setFirstname, value: firstname, style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [RegisterProcedure_web_style_1.styles.input] : undefined }),
                                react_1.default.createElement(react_native_1.View, null, error.firstnameEmpty && (react_1.default.createElement(atome_1.Text, { style: [RegisterProcedure_web_style_1.styles.errorText, GlobalStyles_1.globalStyles.marginTop5] }, enums_1.ErrorMessages.EMPTY_FIELD)))),
                            react_1.default.createElement(react_native_1.View, { style: [
                                    Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                        ? error.lastnameEmpty
                                            ? GlobalStyles_1.globalStyles.marginBottom30
                                            : GlobalStyles_1.globalStyles.marginBottom10
                                        : GlobalStyles_1.globalStyles.flex2,
                                    GlobalStyles_1.globalStyles.flex2,
                                    GlobalStyles_1.globalStyles.marginLeft10,
                                ] },
                                react_1.default.createElement(atome_1.Label, { style: [RegisterProcedure_web_style_1.styles.label] }, "Nachname"),
                                react_1.default.createElement(atome_1.InputField, { hasError: error.lastnameEmpty, onChange: setLastname, value: lastname, style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [RegisterProcedure_web_style_1.styles.input] : undefined }),
                                react_1.default.createElement(react_native_1.View, null, error.lastnameEmpty && (react_1.default.createElement(atome_1.Text, { style: [RegisterProcedure_web_style_1.styles.errorText, GlobalStyles_1.globalStyles.marginTop5] }, enums_1.ErrorMessages.EMPTY_FIELD)))))),
                    react_1.default.createElement(react_native_1.View, { style: Breakpoints_1.isDesktop
                            ? [
                                GlobalStyles_1.globalStyles.marginBottom30,
                                GlobalStyles_1.globalStyles.row,
                                GlobalStyles_1.globalStyles.marginTop10,
                            ]
                            : null },
                        react_1.default.createElement(react_native_1.View, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                ? error.emailEmpty || error.emailCorrect || error.emailTaken
                                    ? [GlobalStyles_1.globalStyles.marginBottom30, GlobalStyles_1.globalStyles.marginTop10]
                                    : [GlobalStyles_1.globalStyles.marginBottom10, GlobalStyles_1.globalStyles.marginTop10]
                                : null },
                            react_1.default.createElement(atome_1.Label, { style: [RegisterProcedure_web_style_1.styles.label] }, "E-Mail-Adresse"),
                            react_1.default.createElement(atome_1.InputField, { hasError: error.emailEmpty || error.emailCorrect, onChange: setEmail, value: email, style: [
                                    Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [RegisterProcedure_web_style_1.styles.input] : RegisterProcedure_web_style_1.styles.emailField,
                                ] }),
                            react_1.default.createElement(react_native_1.View, null, error.emailEmpty && (react_1.default.createElement(atome_1.Text, { style: [RegisterProcedure_web_style_1.styles.errorText, GlobalStyles_1.globalStyles.marginTop5] }, enums_1.ErrorMessages.EMPTY_FIELD))),
                            react_1.default.createElement(react_native_1.View, null, error.emailCorrect && (react_1.default.createElement(atome_1.Text, { style: [RegisterProcedure_web_style_1.styles.errorText, GlobalStyles_1.globalStyles.marginTop5] }, enums_1.ErrorMessages.EMAIL_REQUIREMENTS))),
                            react_1.default.createElement(react_native_1.View, null, error.emailTaken && (react_1.default.createElement(atome_1.Text, { style: [RegisterProcedure_web_style_1.styles.errorText, GlobalStyles_1.globalStyles.marginTop5] }, enums_1.ErrorMessages.EMAIL_TAKEN)))),
                        react_1.default.createElement(react_native_1.View, { style: [
                                Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                    ? error.phoneEmpty || error.phoneShort || error.phoneLong
                                        ? [GlobalStyles_1.globalStyles.marginBottom30, GlobalStyles_1.globalStyles.marginTop10]
                                        : GlobalStyles_1.globalStyles.marginTop10
                                    : null,
                            ] },
                            react_1.default.createElement(atome_1.Label, { style: [RegisterProcedure_web_style_1.styles.label] }, "Telefonnummer"),
                            react_1.default.createElement(atome_1.InputField, { hasError: error.phoneEmpty || error.phoneShort || error.phoneLong, onChange: setphoneNumber, value: phoneNumber, isNumber: true, style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [RegisterProcedure_web_style_1.styles.input] : [RegisterProcedure_web_style_1.styles.phoneField] }),
                            react_1.default.createElement(react_native_1.View, null, (error.phoneEmpty ||
                                error.phoneShort ||
                                error.phoneLong) && (react_1.default.createElement(atome_1.Text, { style: [RegisterProcedure_web_style_1.styles.errorText, GlobalStyles_1.globalStyles.marginTop5] },
                                error.phoneEmpty && enums_1.ErrorMessages.PHONE_EMPTY,
                                error.phoneShort && enums_1.ErrorMessages.PHONE_SHORT,
                                error.phoneLong && enums_1.ErrorMessages.PHONE_LONG)))))),
                react_1.default.createElement(react_native_1.View, { style: [RegisterProcedure_web_style_1.styles.container, GlobalStyles_1.globalStyles.marginBottom12] },
                    react_1.default.createElement(atome_1.Text, { style: [RegisterProcedure_web_style_1.styles.passwordLabel, GlobalStyles_1.globalStyles.marginVertical25] }, "W\u00E4hlen Sie das Passwort f\u00FCr Ihren kostenfreien Therapie-Account"),
                    react_1.default.createElement(react_native_1.View, { style: Breakpoints_1.isDesktop
                            ? [GlobalStyles_1.globalStyles.marginBottom30, GlobalStyles_1.globalStyles.row]
                            : null },
                        react_1.default.createElement(react_native_1.View, { style: [
                                Breakpoints_1.isMobile || Breakpoints_1.isTablet ? GlobalStyles_1.globalStyles.column : null,
                                error.passwordReq
                                    ? GlobalStyles_1.globalStyles.marginBottom10
                                    : GlobalStyles_1.globalStyles.marginBottom10,
                            ] },
                            react_1.default.createElement(atome_1.Label, { style: [RegisterProcedure_web_style_1.styles.label] }, "Passwort"),
                            react_1.default.createElement(atome_1.InputField, { hasError: error.passwordReq, onChange: setPassword, secure: true, value: password, style: Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                    ? [RegisterProcedure_web_style_1.styles.input]
                                    : [RegisterProcedure_web_style_1.styles.passWebInput] }),
                            react_1.default.createElement(react_native_1.View, null, error.passwordReq && (react_1.default.createElement(atome_1.Text, { style: [RegisterProcedure_web_style_1.styles.errorText, GlobalStyles_1.globalStyles.marginTop5] }, enums_1.ErrorMessages.PASSWORD_REQUIREMENTS)))),
                        react_1.default.createElement(react_native_1.View, { style: [
                                Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                    ? (GlobalStyles_1.globalStyles.column, GlobalStyles_1.globalStyles.marginTop25)
                                    : null,
                                error.passwordEqual
                                    ? GlobalStyles_1.globalStyles.marginBottom10
                                    : GlobalStyles_1.globalStyles.marginBottom10,
                            ] },
                            react_1.default.createElement(atome_1.Label, { style: [RegisterProcedure_web_style_1.styles.label] }, "Passwort wiederholen"),
                            react_1.default.createElement(atome_1.InputField, { hasError: error.passwordEqual, onChange: setRepeatedPassword, secure: true, value: repeatedPassword, style: Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                    ? [RegisterProcedure_web_style_1.styles.input]
                                    : [RegisterProcedure_web_style_1.styles.passWebInput] }),
                            react_1.default.createElement(react_native_1.View, null, error.passwordEqual && (react_1.default.createElement(atome_1.Text, { style: [
                                    RegisterProcedure_web_style_1.styles.errorText,
                                    // styles.errorTextPassword2,
                                    GlobalStyles_1.globalStyles.marginTop5,
                                ] }, enums_1.ErrorMessages.PASSWORD_EQUAL)))))),
                react_1.default.createElement(react_native_1.View, { style: GlobalStyles_1.globalStyles.marginVertical25 },
                    react_1.default.createElement(react_native_1.View, { style: [
                            GlobalStyles_1.globalStyles.row,
                            GlobalStyles_1.globalStyles.marginBottom10,
                            GlobalStyles_1.globalStyles.alignTop,
                            GlobalStyles_1.globalStyles.marginTop40,
                            ,
                        ] },
                        react_1.default.createElement(molecules_1.Checkbox, { checked: agbs, label: "", onPress: () => setAgbs(!agbs) }),
                        Breakpoints_1.isMobileOrTablet ? (react_1.default.createElement(atome_1.Label, { style: [GlobalStyles_1.globalStyles.marginBottom15] },
                            "Ich stimme den",
                            ' ',
                            react_1.default.createElement(react_native_1.Pressable, null,
                                react_1.default.createElement(atome_1.Text, { style: [GlobalStyles_1.globalStyles.underlined], onPress: () => openModal(enums_1.TERM.TERMS) }, "allgemeinen Gesch\u00E4ftsbedingungen")),
                            ' ',
                            '\n',
                            "zu.")) : (react_1.default.createElement(atome_1.Label, { style: [GlobalStyles_1.globalStyles.marginBottom15] },
                            "Ich stimme den",
                            ' ',
                            react_1.default.createElement(react_native_1.Pressable, null,
                                react_1.default.createElement(atome_1.Text, { style: [GlobalStyles_1.globalStyles.underlined], onPress: () => openModal(enums_1.TERM.TERMS) }, "allgemeinen Gesch\u00E4ftsbedingungen")),
                            ' ',
                            "zu.")),
                        error.agbs && (react_1.default.createElement(atome_1.Text, { style: [
                                RegisterProcedure_web_style_1.styles.errorTextCheckbox,
                                GlobalStyles_1.globalStyles.marginBottom5,
                            ] }, enums_1.ErrorMessages.REQUIRE_FIELD))),
                    react_1.default.createElement(react_native_1.View, { style: [
                            GlobalStyles_1.globalStyles.row,
                            GlobalStyles_1.globalStyles.marginBottom10,
                            GlobalStyles_1.globalStyles.alignTop,
                        ] },
                        react_1.default.createElement(molecules_1.Checkbox, { checked: dataProtection, label: "", onPress: () => setDataProtection(!dataProtection) }),
                        Breakpoints_1.isMobileOrTablet ? (react_1.default.createElement(atome_1.Label, { style: [GlobalStyles_1.globalStyles.marginBottom15] },
                            "Ich stimme den ",
                            '\n',
                            react_1.default.createElement(react_native_1.Pressable, null,
                                react_1.default.createElement(atome_1.Text, { style: [GlobalStyles_1.globalStyles.underlined], onPress: () => openModal(enums_1.TERM.PRIVACY_POLICY) }, "Angaben zum Datenschutz")),
                            ' ',
                            '\n',
                            " zu.")) : (react_1.default.createElement(atome_1.Label, { style: [GlobalStyles_1.globalStyles.marginBottom15] },
                            "Ich stimme den",
                            ' ',
                            react_1.default.createElement(react_native_1.Pressable, null,
                                react_1.default.createElement(atome_1.Text, { style: [GlobalStyles_1.globalStyles.underlined], onPress: () => openModal(enums_1.TERM.PRIVACY_POLICY) }, "Angaben zum Datenschutz")),
                            ' ',
                            "zu.")),
                        error.dataProtection && (react_1.default.createElement(atome_1.Text, { style: [
                                RegisterProcedure_web_style_1.styles.errorTextCheckbox,
                                GlobalStyles_1.globalStyles.marginBottom5,
                            ] }, enums_1.ErrorMessages.REQUIRE_FIELD))),
                    react_1.default.createElement(react_native_1.View, { style: [
                            GlobalStyles_1.globalStyles.row,
                            GlobalStyles_1.globalStyles.marginBottom10,
                            GlobalStyles_1.globalStyles.alignTop,
                        ] },
                        react_1.default.createElement(molecules_1.Checkbox, { checked: newsletter, label: "", onPress: () => setNewsletter(!newsletter) }),
                        react_1.default.createElement(atome_1.Label, { style: [GlobalStyles_1.globalStyles.marginBottom15] }, "Ich m\u00F6chte \u00FCber Neuigkeiten per Newsletter informiert werden."))),
                react_1.default.createElement(react_native_1.View, { style: [
                        RegisterProcedure_web_style_1.styles.row,
                        Breakpoints_1.isDesktop ? RegisterProcedure_web_style_1.styles.buttonWebContainer : RegisterProcedure_web_style_1.styles.buttonContainer,
                        Breakpoints_1.isMobileOrTablet ? GlobalStyles_1.globalStyles.marginTop30 : null,
                    ] },
                    react_1.default.createElement(react_native_1.Pressable, { pointerEvents: isSaving ? 'none' : 'auto', style: [
                            isSaving ? RegisterProcedure_web_style_1.styles.buttonLoading : RegisterProcedure_web_style_1.styles.button,
                            GlobalStyles_1.globalStyles.saveButtonContainer,
                        ], onPress: save },
                        isSaving ? react_1.default.createElement(InputLoader_1.default, null) : null,
                        react_1.default.createElement(atome_1.Text, { style: [RegisterProcedure_web_style_1.styles.buttonText] }, "Jetzt kostenfreie Anfrage stellen")),
                    Object.values(error).some(value => value === true) && (react_1.default.createElement(atome_1.Text, { style: [RegisterProcedure_web_style_1.styles.errorText, RegisterProcedure_web_style_1.styles.errorTextBottom25] }, enums_1.ErrorMessages.ERROR))),
                react_1.default.createElement(react_native_1.View, { style: [{ width: '100%', height: 150 }, GlobalStyles_1.globalStyles.marginBottom20] },
                    react_1.default.createElement(atome_1.Text, { style: [
                            {
                                width: '100%',
                                textAlign: 'left',
                                fontSize: 10,
                                color: '#B8B8B8',
                            },
                        ] }, "* Eine Fernbehandlung ist nicht in jedem Fall m\u00F6glich. Voraussetzungen sind die Einhaltung anerkannter fachlicher Standards im Sinne des \u00A7 630a BGB (unter Einbezug der naturwissenschaftlichen Erkenntnisse, der \u00E4rztlichen Erfahrung, die zu der Erreichung des \u00E4rztlichen Behandlungsziels erforderlich ist und sich in der Erprobung bew\u00E4hrt hat) sowie die Feststellung, dass abh\u00E4ngig vom Krankheitsbild kein pers\u00F6nlicher Kontakt zwischen Arzt und Patient erforderlich ist. Die Therapieentscheidung wird durch kooperierende \u00C4rzte getroffen."),
                    react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.marginTop15] },
                        react_1.default.createElement(atome_1.Text, { style: [GlobalStyles_1.globalStyles.cookieText] },
                            react_1.default.createElement("a", { style: { textDecoration: 'none', color: '#3db384' }, href: "javascript:UC_UI.showSecondLayer()", rel: "nofollow" }, "Cookie-Pr\u00E4ferenzen"))))))));
}
exports.RegisterProcedure = RegisterProcedure;
